export default "__VITE_ASSET__DmI65thZ__";